import * as React from "react";
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 32381 28809"
    {...props}
  >
    <defs>
      <style>
        {
          // ".str0{stroke:#000;stroke-width:469.293;stroke-linecap:round;stroke-linejoin:round}.fil0{fill:none}"
        }
      </style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_2528315454320">
        <path
          d="M1475 796h29405"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
        <ellipse
          cx={868}
          cy={796}
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
          rx={633}
          ry={562}
        />
        <ellipse
          cx={31514}
          cy={799}
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
          rx={633}
          ry={562}
        />
        <path
          d="M2496 17833s10396-2736 9967-17037"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M6293 16788c2970-1626 8828-5853 8673-15726M5259 17091l2565 10767c85 360-144 717-460 717l-4868-1V1062"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="m5958 16076 3297 9639c113 331-93 691-395 691H7486M29575 17833S19043 15097 19478 796"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="M25729 16788c-3010-1626-8933-5853-8776-15726M26775 17091l-2598 10767c-86 360 146 717 467 717l4932-1V1062"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
        <path
          d="m26068 16076-3340 9639c-115 331 94 691 400 691h1393"
          className="fill-none stroke1"
          style={{
            strokeWidth: 469.293,
            strokeLinejoin: "round",
          }}
        />
      </g>
    </g>
  </svg>
);
export default SvgComponent;
